module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av728-b3b3485739e15f2ef19c44ea38e97165.jpg";